import { } from 'vue';
import BaseSetupService from '@/setup/BaseSetupService';
import { SETTING_TYPE } from '@/typings/enums/SETTING_TYPE';
// import { useTour } from '@orion.ui/orion';

type Props = SetupProps<typeof ModalReleaseNoteSetupService.props>;

export default class ModalReleaseNoteSetupService extends BaseSetupService<Props> {
	static readonly props = {};

	constructor (props?: Props, private _modal?: OrionModal) {
		super(props);
	}


	async closeReleaseNoteAsync () {
		try {
			this._modal?._loader()?.show();
			await this.self.updateUserSettingAsync({
				settingType: SETTING_TYPE.ReleaseNote,
				value: true,
			});
		} finally {
			this._modal?.close();
			/* if (this.responsive.onTabletLandscape) {
				useTour('tourNewNavigation').start();
			} */
		}
	}
}
